import api from "@/lib/api";

const HARF = { "ı": "i", "İ": "i", "I": "i", "ş": "s", "Ş": "s", "ğ": "g", "Ğ": "g", "ü": "u", "Ü": "u", "ö": "o", "Ö": "o", "ç": "c", "Ç": "c" };

export const normTr = (s) => String(s ?? "").replace(/[ıİIşŞğĞüÜöÖçÇ]/g, (c) => HARF[c]).toLowerCase().replace(/\u0307/g, "");

export const eslesir = (q, ...parcalar) => {
  const t = normTr(q).split(/\s+/).filter(Boolean);
  if (!t.length) return true;
  const metin = normTr(parcalar.flat().filter((x) => x != null && typeof x !== "object").join(" "));
  return t.every((x) => metin.includes(x));
};

const onbellek = {};
const anahtar = (uid, kapsam) => `${uid}:${kapsam}`;
export const sonSecilenler = (uid, kapsam) => onbellek[anahtar(uid, kapsam)] || [];
export const sonGetir = async (uid, kapsam) => {
  try { onbellek[anahtar(uid, kapsam)] = (await api.get(`/son-secilenler/${kapsam}`)).data; } catch { }
  return sonSecilenler(uid, kapsam);
};
export const sonaEkle = (uid, kapsam, deger, ayni = (a, b) => a === b) => {
  onbellek[anahtar(uid, kapsam)] = [deger, ...sonSecilenler(uid, kapsam).filter((x) => !ayni(x, deger))].slice(0, 10);
  api.post(`/son-secilenler/${kapsam}`, { deger }).catch(() => {});
};
export const ayniKod = (a, b) => normTr(a).trim() === normTr(b).trim();

export const Vurgu = ({ text, q }) => {
  const s = String(text ?? "");
  const n = normTr(s);
  const araliklar = [];
  normTr(q).split(/\s+/).filter(Boolean).forEach((t) => {
    const i = n.indexOf(t);
    if (i >= 0) araliklar.push([i, i + t.length]);
  });
  if (!araliklar.length) return s;
  araliklar.sort((a, b) => a[0] - b[0]);
  const out = [];
  let son = 0;
  araliklar.forEach(([a, b], k) => {
    if (a < son) return;
    out.push(s.slice(son, a), <mark key={k} className="bg-amber-400/30 text-inherit rounded px-0.5">{s.slice(a, b)}</mark>);
    son = b;
  });
  out.push(s.slice(son));
  return <>{out}</>;
};
